module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops-W.e39b1dad.svg";